<template>
  <div class="mod-pads mod-pads__pads">
    <div class="button-wrapper">
      <button
        :class="{ active: setMode }"
        class="mod-pads__pad mod-pads__pad--set"
        @click="toggleSetMode"
        type="button"
        name="set-mode"
      >
        Set
      </button>
    </div>
    <div class="button-wrapper">
      <button
        :class="{ active: clearMode }"
        class="mod-pads__pad mod-pads__pad--clear"
        @click="toggleClearMode"
        type="button"
        name="clear-mode"
      >
        Clear
      </button>
    </div>
    <div class="button-wrapper">
      <button
        :class="{ active: nudgeMode }"
        class="mod-pads__pad mod-pads__pad--nudge"
        @click="toggleNudgeMode"
        type="button"
        name="nudge-mode"
      >
        Nudge
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModPads",
  computed: {
    setMode() {
      return this.$store.state.config.setMode;
    },
    clearMode() {
      return this.$store.state.config.clearMode;
    },
    nudgeMode() {
      return this.$store.state.config.nudgeMode;
    }
  },
  methods: {
    toggleSetMode() {
      this.$store.commit("toggleSetMode");
    },
    toggleClearMode() {
      this.$store.commit("toggleClearMode");
    },
    toggleNudgeMode() {
      this.$store.commit("toggleNudgeMode");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../partials/vars";

.mod-pads {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 640px;

  &__pad {
    @include btn;
    position: relative;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    margin: 6px 1%;
    height: 20px;
    background-color: $color-gray-d;

    &--set {
      &.active,
      &:active {
        background-color: $color-accent;
      }
    }

    &--clear {
      &.active,
      &:active {
        background-color: $color-atention;
      }
    }

    &.active,
    &:active {
      box-shadow: inset 0px 0px 1px rgba(0, 0, 0, 0.5), 0 1px 0 #a9a9a9;
      transform: translateY(3px);
    }
  }
}
</style>
